import { partial } from '../utils';

const identity = c => c;

export default (node, childProp = 'children', childSelector = identity, partialCheckFunction = partial) =>
    partialCheckFunction(node[childProp], c => childSelector(c).checked) ||
    node[childProp].some(c => childSelector(c).partial);
